import { ConfirmationService, MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyGiftReservationService } from 'app/services/loyalty/loyalty-gift-reservation.service';
import { ActivatedRoute } from '@angular/router';
import { LoyaltyReservationsService } from './../../../services/loyalty/loyalty-reservations.service';
import { LoyaltyPrintTemplateService } from 'app/services/loyalty/loyalty-print-template.service';
import { ReservationPrint } from 'app/models/reservation-print.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-loyalty-reservations',
  templateUrl: './loyalty-reservations.component.html',
  styleUrls: ['./loyalty-reservations.component.css']
})
export class LoyaltyReservationsComponent implements OnInit {
  customerId: number;
  cardId: number;
  acmId: number;
  reservationState: string;
  reservations: any[] = [];
  customer: string;
  cardNumber: string;
  accumulator: string;
  pointsBalance: number;
  prefixQrCode: string;

  listReservation: ReservationPrint[] = [];
  findObject: any;
  quantity: number = 1;
  popUp: boolean = false;
  showDetailsDialog = false;
  popUpTitle = '';
  descriptionPopUp = '';
  labels = {};

  customFilter = KontableComponent.CustomFilter;

  noReservationsMsg: string;

  tempId: number;
  modalTitle = '';
  record: any = {};


  constructor(
    private reservationService: LoyaltyReservationsService,
    private activatedRoute: ActivatedRoute,
    public giftService: LoyaltyGiftReservationService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    public printer: LoyaltyPrintTemplateService,
  ) { }

  ngOnInit() {
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.cardId = this.activatedRoute.snapshot.params['cardId'];
    this.acmId = this.activatedRoute.snapshot.params['acmId'];

    this.giftService.getQrCodePrefix('PRE.QRCODE.GABRIELLI').subscribe(res => this.prefixQrCode = res.param_code);

    this.translateService.get([
      'reservations.noReservations',
      'reservations.reservation'
    ]).subscribe(res => {
      this.noReservationsMsg = res['reservations.noReservations'];
      this.modalTitle = res['reservations.reservation'];
    });

    this.reservationState = this.activatedRoute.snapshot.params['reservationState'];
    this.customer = sessionStorage.getItem('customer');
    this.accumulator = sessionStorage.getItem('acm');
    this.cardNumber = sessionStorage.getItem('cardNo');
    this.pointsBalance = +sessionStorage.getItem('startingBalance');
    this.getReservationsList();
  }

  getReservationsList() {
    //eliminato il cardId come filtro per le prenotazioni ttive/chiuse
    this.reservationService.getReservationItemList(this.customerId, this.acmId, this.reservationState).subscribe(res => {
      if (res && res.length > 0) {
        this.reservations = res;
      } else {
        this.confirmationService.confirm({
          message: this.noReservationsMsg,
          acceptLabel: 'Ok',
          accept: () => this.goBack(),
          rejectVisible: false
        });
      }
    });
  }

  goBack() {
    window.history.back();
  }

  /**
   * Generazione del report completo, partendo dall'id della prenotazione
   */
  generateReportComplete($event){

    this.reservationService.getReservation($event).subscribe(reservation => {reservation.forEach(res => {

      if((res.status.toUpperCase() === "PRENOTATODAPAGARE") && (res.value && res.value > 0)){

        this.findObject = null;
        this.findObject = this.listReservation.find(gift => gift.gift_code == res.gift_code);
        var index = this.listReservation.findIndex(gift => gift.gift_code == res.gift_code);
        if(!this.findObject){
         this.quantity = 1;
        }else{
          this.listReservation.splice(index);
          this.quantity ++;
        }

        this.listReservation.push({
          acm_code: res.acm_code,
          acm_desc: res.acm_desc,
          barcode: res.barcode,
          card_no: res.card_no,
          codice_cliente: res.codice_cliente,
          cust_name: res.cust_name,
          cust_surname: res.cust_surname,
          delivery_type: res.delivery_type,
          dt_reservation: res.dt_reservation,
          gift_code: res.gift_code,
          gift_description: res.gift_description,
          gift_type: res.gift_type,
          gift_type_id: res.gift_type_id,
          id: res.id,
          num_reservation: res.num_reservation,
          points: res.points,
          points_balance: res.points_balance,
          points_pre: res.points_pre,
          points_used: res.points_used,
          prefix_qrcode: this.prefixQrCode,
          status: res.status,
          store_code: res.store_code,
          store_desc: res.store_desc,
          value: res.value,
          quantity: this.quantity,
          catalog_desc: res.catalog_desc,
          pay_code: res.payCode,
          auth_pay_code: res.authPayCode
        });
      }
      else{
        return;
      }
    })
    this.printer.generateReportPagamentoComplete(this.listReservation);
    this.closePopUp();
    });
  }

  /**
   * Metodo per la visualizzazione del pop-up con le informazioni dettagliate del record in cui si preme il button
   * @param $event
   */
   showDetails(event){
    this.tempId = event.id = event.num_reservation;
    this.record = event;
    this.showDetailsDialog = true;
  }

  /**
   * Chiusura pop-up
   */
  closePopUp(){
    this.popUp = false;
  }

  /**
   * Aggiunge punti dopo una credit andata a buon fine
   */
  creditPoints(points) {
    this.pointsBalance += points;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-reservations.component.ts